
export default {
  placeDetails: {
    'layer': 'Capa',
    'lat': 'Lat.',
    'lon': 'Lon.',
    'notAvailable': 'No disponible',
    'placeDetails': 'Detalles de la ubicación',
    'placeName': 'Nombre',
    'latlngCopied': 'Latitud y longitud copiadas',
    'lnglatCopied': 'Longitud y latitud copiadas',
    'copyLatlng': 'Copia en formato de latitud y longitud',
    'copyLnglat': 'Copia en formato de longitud y latitud',
    'satelliteView': 'Vista del satélite'
  }
}
